// extracted by mini-css-extract-plugin
export var body = "_3m-1";
export var bodyPadded = "_3m-2";
export var chevron = "_3m-4";
export var chevronOpen = "_3m-5";
export var header = "_3m-0";
export var icon = "_3m-3";